// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"17a2358b","150":"92dcd4c7","488":"7a876c9d","698":"4e5c0d40","850":"d8d877b4","940":"4016da3b"}[chunkId] + ".chunk.js";
};